module.exports = __webpack_public_path__ + "static/media/Info.7c8c307a.svg";